import { ReactNode, useEffect, useRef, useState } from "react";
import { IUser } from "sierra";
import api from "../utils/axios";
import { AuthContext, TAuthLoginFunction } from "../contexts/AuthContext";
import { useApp } from "../contexts/AppContext";

export const AuthProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [user, setUser] = useState<IUser | null>(null);
    const [userLoaded, setUserLoaded] = useState(false);
    const { setLang } = useApp()

    useEffect(() => {
        if (!user) return;
        setLang(user.lang)
        localStorage.setItem("lang", user.lang)
    }, [user])

    // Fetch user data
    const fetchUser = (callback?: () => void) => {
        const token = localStorage.getItem('jwt_token')
        if (!token) {
            setUserLoaded(true)
            callback && callback();
            return;
        }
        api.get('/auth/user', { meta: { showSnackbar: false } }).then(res => setUser(res.data)).catch(console.error).finally(() => {
            setUserLoaded(true)
            callback && callback()
        })
    };

    // Log in the user
    const login: TAuthLoginFunction = (email, password, { onSuccess, onError }) => {
        api.get('/auth/token', { headers: { Authorization: `Basic ${btoa(`${email}:${password}`)}` } }).then(res => {
            const jwt_token = res.data.jwt_token
            if (!jwt_token) throw Error('Invalid response for /auth/token endpoint')
            localStorage.setItem('jwt_token', jwt_token)
            fetchUser(onSuccess)
        }).catch(onError)
    };

    // Log out the user
    const logout = (callback?: () => void) => {
        localStorage.removeItem('jwt_token');
        setUser(null);
        callback && callback();
    };

    return (
        <AuthContext.Provider value={{ user, userLoaded, fetchUser, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};
